import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { logInUser } from "../../store/reducer/UserReducer";
import { setToken } from "../../utils/localStorageMethods";
import { useNavigate } from "react-router-dom";
import { useSendMessageMutation } from "../../store/api/configurationSlice";
import { useTranslation } from "react-i18next";

const SubmitTicket = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.UserReducer);
  const [formData, setFormData] = useState({ email: "", description: "" });

  const [sendMessage, { isLoading }] = useSendMessageMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();

    if (isLoading) return;

    try {
      const response = await sendMessage(formData).unwrap();

      if (response.statusCode === 201) {
        toast.success(response.message);
      }
      setFormData((prev) => ({ ...prev, description: "" }));
    } catch (err) {
      const errorMessage = err.data?.message || "Something went wrong";
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    if (user) {
      setFormData((prev) => ({ ...prev, email: user.email }));
    }
  }, [user]);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className='mb-3'>
          <label className='form-label'>{t("email")}</label>
          <input
            type='text'
            value={formData.email}
            className='formInput'
            readOnly
          />
        </div>

        <div className='mb-3'>
          <label className='form-label'>{t("description")}</label>
          <textarea
            className='formInput'
            rows={4}
            placeholder={`${t("describe")} ${t("the")} ${t("issue")}...`}
            value={formData.description}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, description: e.target.value }))
            }
          />
        </div>

        <Button
          type='submit'
          disabled={isLoading}>
          {isLoading ? (
            <>
              <span
                className='spinner-border spinner-border-sm me-2'
                role='status'>
                <span className='visually-hidden'>{t("loading")}...</span>
              </span>
            </>
          ) : (
            t("submit")
          )}
        </Button>
      </form>
    </div>
  );
};

export default SubmitTicket;
